import { render, staticRenderFns } from "./FetchContainer.vue?vue&type=template&id=2b314592"
import script from "./FetchContainer.vue?vue&type=script&lang=js"
export * from "./FetchContainer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports